import React from "react";

const CheckoutPage = () => (
  <div className="mx-auto max-w-xl p-6 bg-gray-50 rounded-lg shadow overflow-y-auto">
    <h2 className="text-2xl font-semibold mb-4">Paiement</h2>

    <div className="space-y-4">
      <div>
        <label className="block mb-1 font-medium">Montant total (€)</label>
        <input
          type="number"
          placeholder="Montant"
          className="w-full border rounded-md p-2"
        />
      </div>

      <div>
        <label className="block mb-1 font-medium">Référence de la commande</label>
        <input
          type="text"
          placeholder="REF-12345"
          className="w-full border rounded-md p-2"
        />
      </div>

      <div>
        <label className="block mb-1 font-medium">Pseudo TikTok</label>
        <input
          type="text"
          placeholder="Ton pseudo TikTok"
          className="w-full border rounded-md p-2"
        />
      </div>

      <button className="mt-4 bg-blue-600 text-white py-2 px-4 rounded-md w-full">
        Passer au paiement
      </button>
    </div>
  </div>
);

export default CheckoutPage;
